import { render, staticRenderFns } from "./SetupManager.vue?vue&type=template&id=788b485e&scoped=true&"
import script from "./SetupManager.vue?vue&type=script&lang=js&"
export * from "./SetupManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788b485e",
  null
  
)

export default component.exports